import { useEffect } from 'react';

export default function useReveal(deps: any[] = []) {
  useEffect(() => {
    const revealAll = () => {
      const els = document.querySelectorAll('.reveal');
      els.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight + 300 || rect.top === 0) {
          el.classList.add('in');
        }
      });
    };

    revealAll();

    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
          }
        }),
      { threshold: 0.01 },
    );

    const els = document.querySelectorAll('.reveal');
    els.forEach((el) => io.observe(el));

    // Instant fallback ensures content is never stuck invisible
    const timer = setTimeout(() => {
      document.querySelectorAll('.reveal').forEach((el) => el.classList.add('in'));
    }, 100);

    return () => {
      clearTimeout(timer);
      io.disconnect();
    };
  }, deps);
}